import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { commaSeprateString } from "../../Utils/commonFunctions";
import { Text, Rect, Circle } from "@react-pdf/renderer";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const AdminQuestionOption = (prop) => {
  let questionType = prop.questionType;
  let isChart = prop.isChart;
  let options = prop.options;
  let colors = prop.colors;
  let tmpOptions1 = options.replace(/'/g, '"');
  let tmpOptions2 = JSON.parse(tmpOptions1);
  return (
    <>
      <div
        className="sar-answer"
        key="123"
        style={{ border: "none", padding: "0px" }}
      >
        <div className="sar-answer1">
          {(questionType === "radio" || questionType === "survey") &&
            tmpOptions2.map((item, i) => {
              return (
                <div className="sar-answer-item1" key={i}>
                  <div className="sar-answer-content">
                    <span>
                      <i
                        className="fa fa-circle-thin"
                        style={{
                          fontSize: "20px",
                          color: isChart === 1 ? colors[i] : "",
                          marginRight: "4px",
                          float: "left",
                          padding: "1px",
                        }}
                        aria-hidden="true"
                      ></i>
                    </span>
                    {item.label}
                  </div>
                </div>
              );
            })}
          {questionType === "selectboxes" &&
            tmpOptions2.map((item, i) => {
              return (
                <div className="sar-answer-item1" key={i}>
                  <div className="sar-answer-content">
                    <span>
                      <i
                        className="fa fa-square-o"
                        style={{
                          fontSize: "20px",
                          color: isChart === 1 ? colors[i] : "",
                          marginRight: "4px",
                          float: "left",
                          padding: "1px",
                        }}
                        aria-hidden="true"
                      ></i>
                    </span>
                    {item.label}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export const AdminQuestionOptionDownload = (prop) => {
  let questionType = prop.questionType;
  let isChart = prop.isChart;
  let options = prop.options;
  let colors = prop.colors;
  let tmpOptions1 = options.replace(/'/g, '"');
  let tmpOptions2 = JSON.parse(tmpOptions1);
  return (
    <>
      {(questionType === "radio" || questionType === "survey") &&
        tmpOptions2.map((item, i) => {
          let y = 25;
          y += i * 25;
          return (
            <>
              <Circle
                cx="15"
                cy={y}
                r="6"
                fill={isChart === 1 ? colors[i] : "#ddd"}
                key={i}
              />
              <Text x="30" y={y + 4} style={{ fontSize: 11 }}>
                {item.label}
              </Text>
            </>
          );
        })}
      {questionType === "selectboxes" &&
        tmpOptions2.map((item, i) => {
          let y = 20;
          y += i * 25;
          return (
            <>
              <Rect
                x="10"
                y={y}
                width="10"
                height="10"
                fill={isChart === 1 ? colors[i] : "#ddd"}
              />
              <Text x="30" y={y + 9} style={{ fontSize: 11 }}>
                {item.label}
              </Text>
            </>
          );
        })}
    </>
  );
};

export const AdminAnalysisGraph = (props) => {
  const labels = [""];
  let obj1 = JSON.parse(props.reportsCharts.graphdata);
  let obj2 = obj1.datasets;
  let region = commaSeprateString(props.reportsCharts.graph_region);
  let country = commaSeprateString(props.reportsCharts.graph_country);
  let profession = commaSeprateString(props.reportsCharts.graph_profession);
  let finalPassObjects = Object.values(obj2);
  console.log(finalPassObjects)
  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: obj1.title,
        padding: {
          top: 10,
          bottom: 10,
        },
        color: "#0069d9",
      },
      scales: {
        xaxis: {
          beginAtZero: true,
          ticks: {
            stepSize: 1.0,
          },
        },
      },
    },
  };
  return (
    <div className="col-md-12">
      <div className="row chart-box gx-3">
        <div className="col-md-8">
          <Bar
            options={options}
            data={{
              labels,
              datasets: finalPassObjects,
            }}
          />
          <span className="pull-right">
            <button
              className="btn btn-sm custom-btn-primary"
              data-toggle="modal"
              data-target="#modal-chart"
              onClick={() => {
                props.handlePopup(obj1.title, finalPassObjects);
              }}
            >
              <i className="fa fa-eye"></i>
            </button>{" "}
            &nbsp;
            <button
              className="btn btn-sm btn-danger"
              data-toggle="modal"
              data-target="#modal-default"
              onClick={() => {
                props.handleDelete(props.reportsCharts.analysis_id);
              }}
            >
              <i className="fa fa-trash"></i>
            </button>
          </span>
        </div>
        <div className="col-md-4">
          <br></br>
          <span>
            <strong>Region:</strong> {region}
          </span>
          <br></br>
          <span>
            <strong>Country:</strong> {country}
          </span>
          <br></br>
          <span>
            <strong>Profession:</strong> {profession}
          </span>
        </div>
      </div>
    </div>
  );
};

export const AdminReportGraph = (props) => {
  const labels = [""];
  
  let obj1 = JSON.parse(props?.reportsCharts?.graphdata);
  let obj2 = obj1?.datasets;
  let region = commaSeprateString(props?.reportsCharts?.graph_region);
  let country = commaSeprateString(props?.reportsCharts?.graph_country);
  let profession = commaSeprateString(props?.reportsCharts?.graph_profession);
  let surveyStatus = props?.surveyStatus;
  console.log(obj2)
  let finalPassObjects = Object.values(obj2);
  console.log("finalpass",finalPassObjects)

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: obj1?.title,
        padding: {
          top: 10,
          bottom: 10,
        },
        color: "#0069d9",
      },
      scales: {
        xaxis: {
          beginAtZero: true,
          ticks: {
            stepSize: 1.0,
          },
        },
      },
    },
  };
  return (
    <div className="col-md-12">
      <div className="row chart-box gx-3">
        <div className="col-md-8">
          <Bar
            options={options}
            data={{
              labels,
              datasets: finalPassObjects,
            }}
          />
          <span className="pull-right">
            <button
              className="btn btn-sm custom-btn-primary"
              data-toggle="modal"
              data-target="#modal-chart"
              onClick={() => {
                props.handlePopup(obj1?.title, finalPassObjects);
              }}
            >
              <i className="fa fa-eye"></i>
            </button>{" "}
            {surveyStatus !== "survey_closed" && (
              <button
                className="btn btn-sm btn-danger"
                data-toggle="modal"
                data-target="#modal-default"
                onClick={() => {
                  props.handleDelete(props?.reportsCharts?.report_id);
                }}
              >
                <i className="fa fa-trash"></i>
              </button>
            )}
          </span>
        </div>
        <div className="col-md-4">
          <br></br>
          <span>
            <strong>Region:</strong> {region}
          </span>
          <br></br>
          <span>
            <strong>Country:</strong> {country}
          </span>
          <br></br>
          <span>
            <strong>Profession:</strong> {profession}
          </span>
        </div>
      </div>
    </div>
  );
};
export const AnalysisReportAdminGraph = (props) => {
  const labels = [""];
  let obj1 = JSON.parse(props.reportsCharts.graphdata);
  let obj2 = obj1.datasets;
  let region = commaSeprateString(props.reportsCharts.graph_region);
  let country = commaSeprateString(props.reportsCharts.graph_country);
  let profession = commaSeprateString(props.reportsCharts.graph_profession);
  let finalPassObjects = Object.values(obj2);
  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: obj1.title,
        padding: {
          top: 10,
          bottom: 10,
        },
        color: "#0069d9",
      },
      scales: {
        xaxis: {
          beginAtZero: true,
          ticks: {
            stepSize: 1.0,
          },
        },
      },
    },
  };
  return (
    <div className="col-md-12 border p-2">
      <div className="row">
        <div className="col-md-8">
          <Bar
            options={options}
            data={{
              labels,
              datasets: finalPassObjects,
            }}
          />
        </div>
        <div className="col-md-4">
          <br></br>
          <span>
            <strong>Region:</strong> {region}
          </span>
          <br></br>
          <span>
            <strong>Country:</strong> {country}
          </span>
          <br></br>
          <span>
            <strong>Profession:</strong> {profession}
          </span>
        </div>
      </div>
    </div>
  );
};

export const AdminTextResponces = (prop) => {
  let label = prop.label;
  let textResponseItem = prop.textResponseItem;
  if (textResponseItem.length > 0) {
    return (
      <Accordion key={prop.key1} className="mb-2">
        <Accordion.Item eventKey={prop.key1}>
          <Accordion.Header>Option: "{label}"</Accordion.Header>
          <Accordion.Body className="text-left">
            {textResponseItem.map((item, j) => {
              return <p key={j}>{item.text_responce}</p>;
            })}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  } else {
    return <></>;
  }
};
export const AdminTextResponcesPriview = (props) => {
  let label = props.label;
  let textResponseItem = props.textResponseItem;
  if (textResponseItem.length > 0) {
    return (
      <Accordion key={props.key1} className="mb-2">
        <Accordion.Item eventKey={props.key1}>
          <Accordion.Header>Option: "{label}"</Accordion.Header>
          <Accordion.Body className="text-left">
            {textResponseItem.map((item, j) => {
              return <p key={j}>{item.text_responce}</p>;
            })}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  } else {
    return <></>;
  }
};

export const AdminTextResponcesReportPdf = (props) => {
  let label = props.label;
  let textResponseItem = props.textResponseItem;
  if (textResponseItem.length > 0) {
    return (
      <>
        <div
          style={{
            padding: "5px",
            border: 1,
            borderRadius: 5,
            borderColor: "#dee2e6",
            marginLeft: 3,
            marginBottom: 5,
            marginTop: 5,
          }}
        >
          <Text style={{ fontSize: 9, marginBottom: 2 }}> Option: {label}</Text>
          {textResponseItem.map((item, j) => {
            return (
              <Text key={j} style={{ fontSize: 8, padding: "4px" }}>
                {item.text_responce}
              </Text>
            );
          })}
        </div>
      </>
    );
  } else {
    return <></>;
  }
};
